var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "header-logo",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 211.2 63.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#29a7df}\n      ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_x2F_light_x2F_long"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_x2F_dark_x2F_long",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "actioniq",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actioniq"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.8 47.9c-.7 1.4-2.2 1.7-3.7 1.4-1.3-.7-2.2-2.2-1.3-4L13.7 22c1.1-2.2 4.1-2.3 5.1 0l11.7 23.3c1.7 3.2-3.3 5.8-4.8 2.6l-1.8-3.7H8.6l-1.8 3.7zm4.4-9.2H21l-4.7-10.3-5.1 10.3zm36.7 10.9c-10 0-14.6-6.8-14.6-14.9s5-14.9 14.6-14.9c3.6 0 6.5 1.1 9.5 3.7 1.1 1 1.2 2.9.1 4-1.1 1-2.8.9-3.8-.1-1.7-1.8-3.4-2.3-5.8-2.3-6.4 0-9.5 4.5-9.5 9.6s3 9.9 9.5 9.9c2.4 0 4.6-1 6.5-2.7 1.3-1 3.1-.5 3.8.5.7.9 1 2.4-.5 3.9-2.9 2.7-6.4 3.3-9.8 3.3zm23.5-2.9v-21h-7.3c-3.6 0-3.6-5.3 0-5.3h19.6c3.7 0 3.7 5.3 0 5.3h-6.9v21c.1 3.6-5.4 3.7-5.4 0zm19.4 0V23c0-3.4 5.5-3.5 5.5 0v23.7c0 3.5-5.5 3.6-5.5 0zm41.1-12c0 9.8-7.6 14.9-14.9 14.9-7.7.3-15.7-4.8-15.7-14.9 0-10.2 8-15.2 15.7-15.2 7.3.4 14.9 5.4 14.9 15.2zm-5.5 0c0-6.6-5.1-9.8-9.9-9.8-4.6 0-9.7 3.3-9.7 9.8 0 6.5 5.1 9.8 9.7 9.8 4.8.1 9.9-3.2 9.9-9.8zM137 46.4v-23c0-1.5.3-2.9 2.5-2.9 1.5 0 1.8.4 2.9 1.5l13.7 17.2V23c0-1.4 1.2-2.9 2.6-2.9 1.5 0 2.9 1.5 2.9 2.9v23.4c0 1.8-1.1 2.5-2.2 2.9-1.5 0-2.2-.3-3.4-1.5l-13.7-17.4v16c0 1.8-1.1 2.9-2.6 2.9s-2.7-1.1-2.7-2.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#13202c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    className: "st1",
    d: "M209.3 35.1c0 3.9-1 6.8-2.9 9.4l.7.8c2.7 2.5-.8 6.6-3.6 3.9l-1.4-1.1c-2.2 1.5-4.7 2.2-8.1 2.2-7.3 0-15.7-5-15.7-15.2s8.3-15.4 15.7-15.4c7.8 0 15.3 5.2 15.3 15.4zm-6.8 5.4c1-1.5 1.5-3.2 1.5-5.4 0-6.6-5.2-10-9.9-10-5.1 0-10.1 3.4-10.1 10 0 5 4.3 9.8 10.1 9.8 1.5 0 2.9-.4 4.4-.7l-4.7-4.4c-2.2-2.7 1.3-6.4 4.1-4l4.6 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M167.9 46.7c0 3.5 5.5 3.4 5.5 0V23c0-3.5-5.5-3.4-5.5 0v23.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NODE_x2F_blue",
    transform: "translate(33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st1",
    cx: 60.5,
    cy: 19.4,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    className: "st1",
    cx: 60.5,
    cy: 2.8,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    className: "st1",
    cx: 68.8,
    cy: 11.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    fill: "none",
    stroke: "#29a7df",
    strokeWidth: 0.3,
    d: "M60.5 2.8l8.3 8.3-8.3 8.3"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee04a0cb6c5cabb181d10ff522380509.svg";
export { ForwardRef as ReactComponent };